import React, { useEffect, useState } from "react";
import "./PublicCertificate.scss";
import { generateCertificates } from "../../../utils/apis/userApi";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { returnErrors } from "../../../utils/store/reducers/Error";
import LoaderOverlay from "../../../reusableComponents/LoaderOverlay/Index";

const PublicCertificate = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { certificate_id } = useParams();
  const dispatch = useDispatch();

  const getCertificate = async () => {
    setLoading(true);
    try {
      const response = await generateCertificates(certificate_id, "get");
      setData(response.data);
    } catch (error) {
      dispatch(returnErrors(error?.response?.data?.error || "Something went wrong", 400));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCertificate();
  }, [certificate_id]);

  return (
    <div className="public-certificate-box-wrapper">
      <div className="public-certificate-box">
        {loading ? (
          <LoaderOverlay />
        ) : data?.file ? (
          <>
            <img src={data.file} alt="Certificate" />
            <div className="bottom_btns">
              <a
                href={data.file}
                target="_blank"
                rel="noopener noreferrer"
                className="gradient-border-btn"
                download
              >
                Download
              </a>
            </div>
          </>
        ) : (
          <p>No certificate found.</p>
        )}
      </div>
    </div>
  );
};

export default PublicCertificate;
